import * as GlobalNotificationActions from './../actions/global-notification.action';
import { IAppState } from './../../state/app.state';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

@Injectable()
export class GlobalNotificationFacade {

    constructor(private store: Store<IAppState>) { }

    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     */
    public dismissGlobalNotification() {
        this.store.dispatch(new GlobalNotificationActions.NotificationResetAction('reset'));
    }

    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     * 
     * Dispatch success message.
     */
    public dispatchSuccessNotification(message : string) {
        this.store.dispatch(new GlobalNotificationActions.NotificationSuccessAction(message));
    }

    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     * 
     * Dispatch error message, this will concatenate message and errorMessage.
     * This does not add spacing, leaving on caller to adjust that formatting.
     */
    public dispatchErrorNotification(message : string, error : any) {
        const errorMessage: string = (error && error.error && error.error.message) ? error.error.message : (error && error.message) ? error.message : 'An unknown error has occured';
        this.store.dispatch(new GlobalNotificationActions.NotificationErrorAction(`${message} ${errorMessage}`));
    }
}
